import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { UrlGeneratorService } from '@app/core/i18n';

@Injectable()
export class SocialShareService {
  private url: any;

  constructor(router: Router, urlGenerator: UrlGeneratorService) {
    this.url = urlGenerator.generateUrl(router.url);
  }

  getAllShareLink(imgPath, description = '') {
    const shareLinks = { facebook: '', twitter: '', pinterest: '', google: '', tumblr: '' };

    shareLinks.facebook = this.getFacebookShareLink(imgPath);
    shareLinks.twitter = this.getTwitterShareLink(description);
    shareLinks.pinterest = this.getPinterestShareLink(imgPath, description);
    shareLinks.google = this.getGoogleShareLink();
    shareLinks.tumblr = this.getTumblrShareLink(imgPath);

    return shareLinks;
  }

  getFacebookShareLink(imgPath = '') {
    return 'https://www.facebook.com/sharer/sharer.php?u=' + this.url + '&src=' + imgPath;
  }

  getTwitterShareLink(text) {
    return 'https://twitter.com/intent/tweet?text=' + text + '&url=' + this.url;
  }

  getPinterestShareLink(imgPath, text) {
    return (
      'https://pinterest.com/pin/create/bookmarklet/?media=' +
      imgPath +
      '&url=' +
      this.url +
      '&is_video=false&description=' +
      text
    );
  }

  getGoogleShareLink() {
    return 'https://plus.google.com/share?url=' + this.url;
  }

  getTumblrShareLink(imgPath) {
    return 'https://www.tumblr.com/share/photo?source=' + imgPath + '&click_thru=' + this.url;
  }
}
